import { ZfPill, ZfStack, ZfTypography } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import type { IPointUsage } from '../../../interfaces/topic';

interface ITalkingPointUsagesProps {
    usages: IPointUsage[];
}

export const TalkingPointUsages: FunctionComponent<ITalkingPointUsagesProps> = ({ usages }) => {
    const { i18n, t } = useTranslation();

    if (usages === null) return <>{t('genericLoadingFailed')}</>;
    if (!usages.length) return <>{t('contentAdmin.unused')}</>;

    return (
        <ZfStack direction="column" spacing="small">
            <ZfTypography variant="label-large" weight="bold">
                {t('contentAdmin.usedInTopics')}
            </ZfTypography>
            <ZfStack direction="row" spacing="medium">
                {usages.map((usage) => (
                    <ZfPill key={usage.id} color="primary" clickable={false}>
                        {usage.name[i18n.language]}
                    </ZfPill>
                ))}
            </ZfStack>
        </ZfStack>
    );
};
